@if (snackbarState$ | async; as state) {
	<bci-wk-snackbars [type]="state.type" [autoHide]="state.autoHide" [retry]="false">
		<span>{{ state.message }}</span>
	</bci-wk-snackbars>
}
